import axios, { AxiosRequestConfig } from "axios";
const hostname = window.location.hostname;
export const BASE_URL = hostname === "localhost" ? "http://localhost:8080" : hostname === "dev.auditzen.ai" ? "https://dev.api.auditzen.ai" : hostname === "qa.auditzen.ai" ? "https://qa.api.auditzen.ai" : hostname.endsWith(".auditzen.ai") ? `https://${hostname.split(".")[0]}.api.auditzen.ai` : `https://${hostname.split(".")[0]}.api.auditzen.ai`;
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
  withCredentials: true,
});
export const s3AxiosInstance = axios.create();
export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName.trim() === name) {
      return cookieValue;
    }
  }
  return null;
};
export const hasAuthCookie = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("token")) return true;
  if (getCookie("accessToken")) return true;
  return !!localStorage.getItem("email");
};
export const checkAuthStatus = async (): Promise<boolean> => {
  return hasAuthCookie();
};
export const clearAuthCookie = () => {
  const cookiesToClear = ["accessToken", "sessionKey"];
  cookiesToClear.forEach(cookieName => {
    document.cookie = `${cookieName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict`;
    if (window.location.hostname !== 'localhost') {
      document.cookie = `${cookieName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict; Secure`;
    }
  });
  sessionStorage.clear();
  const keysToRemove = ["userInfo", "permissions", "functionCampaignName", "campaignName", "roleId", "clientId", "clientName", "roleName", "providerId", "firstName", "lastName", "email", "sessionKey", "isHistoryAvailable", "qcBufferDate", "projectTableColumns"];
  keysToRemove.forEach((key) => localStorage.removeItem(key));
};
const handleUnauthorizedOrForbidden = () => {
  clearAuthCookie();
  const modal = document.createElement("div");
  modal.innerHTML = `
    <div id="session-modal" style="
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 2000;
      opacity: 0;
      animation: fadeIn 0.3s ease-in-out forwards;
    ">
      <div id="modal-content" style="
        background: white;
        padding: 20px;
        font-weight: bolder;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        text-align: center;
        width: 300px;
        transform: scale(0.8);
        animation: scaleUp 0.3s ease-in-out forwards;
      ">
        <h3 style="color: red;">Session Expired</h3>
        <p>Your session has expired. Redirecting...</p>
      </div>
    </div>
    <style>
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleUp {
        from { transform: scale(0.8); }
        to { transform: scale(1); }
      }
    </style>
  `;
  document.body.appendChild(modal);
  setTimeout(() => {
    window.location.href = '/login';
  }, 1500);
};
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      handleUnauthorizedOrForbidden();
    }
    return Promise.reject(error);
  }
);
export const apiCall = async (
  method: "get" | "post" | "put" | "patch" | "delete",
  endpoint: string,
  data?: any,
  params?: any,
  config?: AxiosRequestConfig,
  isS3Request: boolean = false
): Promise<any> => {
  try {
    const instance = isS3Request ? s3AxiosInstance : axiosInstance;
    const response = await instance({
      method,
      url: endpoint,
      params,
      data,
      ...config,
    });
    return response.data;
  } catch (error: any) {
    console.error(`API Error (${endpoint}):`, error.response?.data || error.message);
    throw error;
  }
};